import { store } from '@app/state';

export const isSignedIn = (): boolean => {
  return !!store.getState().auth.idToken;
};
